import { fetchJSON } from '../utils/fetch';

export const fetchLicenseInformation = (cloudId: string) =>
	fetchJSON(`/gateway/api/xflow/${cloudId}/license-information`);
